import { Target, Pencil, Code, Rocket } from 'lucide-react';

export function Process() {
  const steps = [
    {
      number: "1",
      title: "OBJECTIFS",
      description: "Analyse de vos besoins et définition de votre projet",
      icon: Target,
      color: "bg-cyan-400"
    },
    {
      number: "2",
      title: "DESIGN & MAQUETTE",
      description: "Création de l'identité visuelle et des maquettes",
      icon: Pencil,
      color: "bg-yellow-400"
    },
    {
      number: "3",
      title: "DÉVELOPPEMENT",
      description: "Codage et intégration de toutes les fonctionnalités",
      icon: Code,
      color: "bg-orange-600"
    },
    {
      number: "4",
      title: "MISE EN LIGNE",
      description: "Déploiement et lancement de votre projet",
      icon: Rocket,
      color: "bg-violet-600"
    }
  ];

  return (
    <section className="bg-white py-20 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-5xl md:text-6xl font-black mb-16 text-center">
          LE PROCESSUS
        </h2>

        <div className="relative">
          {/* Zigzag connector line */}
          <svg
            className="absolute top-0 left-0 w-full h-full hidden md:block"
            style={{ zIndex: 0 }}
          >
            <path
              d="M 15% 25% L 35% 35% L 65% 25% L 85% 35%"
              stroke="black"
              strokeWidth="4"
              fill="none"
              strokeDasharray="12 8"
            />
          </svg>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative" style={{ zIndex: 1 }}>
            {steps.map((step, index) => (
              <div
                key={index}
                className={`${step.color} border-4 border-black p-6 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-1 hover:translate-y-1 transition-all ${
                  index % 2 === 0 ? 'md:mt-0' : 'md:mt-12'
                }`}
              >
                <div className="bg-white border-4 border-black w-16 h-16 flex items-center justify-center mb-4">
                  <step.icon className="w-8 h-8" />
                </div>
                <div className="bg-black text-white w-12 h-12 flex items-center justify-center font-black text-2xl mb-4 border-4 border-black">
                  {step.number}
                </div>
                <h3 className="text-2xl font-black mb-3">{step.title}</h3>
                <p className="font-bold">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
